
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Combobox from '../../../core/components/Generics/Combobox/Combobox.vue';
import Input from '../../../core/components/Generics/Input.vue';
import LoadingIndicator from '../../../core/components/Generics/LoadingIndicator.vue';
import Button from '../../../core/components/Generics/Button.vue';
import OverwriteGeneralMapOption from '../OverwriteGeneralMapOption.vue';

import { EventBus, TypeEventBus } from '../../../../features/core/utils';
import { ComboSelectedOption } from '../../../core/components/Generics/Combobox/Combobox';
import { ItemServices } from '../../../../features/core/api/ItemServices';
import { Farming } from '../../../../features/typescript/farming';
import { ItemBasic } from '../../../../features/typescript/itemInfo';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import { Feature, FeatureCollection, MultiPolygon } from '../../../../features/typescript/MapShapes';
import { convertToGeoJSON } from '../../../../features/core/utils/map-utils';
import { filterFeaturesById } from '../../../../features/helpers/geojson';

@Component({
  components: {
    Button,
    Combobox,
    OverwriteGeneralMapOption,
    SimpleMap,
    LoadingIndicator,
    Input
  }
})
export default class ModalListItems extends Vue {
  isSexagesimal: boolean = false;
  visible: boolean = true;
  modalTitle: string = 'Listado de items precargados';
  yearOptions: Array<ComboSelectedOption> = [];
  yearSelected: ComboSelectedOption | null = null;
  yearSelectedRv: boolean = false;
  polygonsList: Array<ItemBasic> = [];
  loadingPolygons: boolean = false;
  selectedItems: Array<ItemBasic> = [];
  yearMultiPolygon: MultiPolygon | null = null;
  overwriteGeneralMap: boolean = false;
  search: string = '';
  headers: any[] = [
    {
      text: 'Nombre',
      value: 'name'
    },
    {
      text: 'Acciones',
      value: 'actions',
      width: '40px',
      sortable: false
    }
  ];

  get areSelectedItems() {
    return this.selectedItems.length > 0;
  }



  created(){
    this.setYearOptions();
  }

  updateYearSelected(value){
    this.yearSelected = value;
    this.getPolygonsByYear(value)
  }

  getPolygonsByYear(value){
    if(!value){
      this.polygonsList = [];
      return;
    }

    this.yearMultiPolygon = null;
    this.loadingPolygons = true;
   
    ItemServices.getPreloadedItemsByYear(
      value.id
    ).then((response) => {
      this.polygonsList = response.list
      this.yearMultiPolygon = response.polygons
    }).finally(() => {
      this.loadingPolygons = false;
    })
  }

  updateYearSelectedRv(value){
    this.yearSelectedRv = value;
  }
  setYearOptions() {
      const startCampaignYear = 2022;
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;
      const campaignStartMonth = 8;

      const lastStartYear = currentMonth > campaignStartMonth ? currentYear : currentYear - 1;

      this.yearOptions = [];

      for (let year = startCampaignYear; year <= lastStartYear; year++) {
        const formatShortYear = (year) => year.toString().slice(-2);

        const startShort = formatShortYear(year);
        const endShort   = formatShortYear(year + 1);
        const label      = `${startShort}/${endShort}`;

        this.yearOptions.push({
          id: year,
          value: label
        });
      }
    }


  selectRanchsInTable(selectedFeaturesInMap: Array<google.maps.Data.Feature>) {
    const incomingIds = selectedFeaturesInMap
      .map(f => f.getProperty('id') || f.getProperty('customId'))
      .filter(id => id != null) as Array<number|string>;

    this.selectedItems = this.selectedItems.filter(item =>
      incomingIds.includes(item.id)
    );

    incomingIds.forEach(id => {
      const already = this.selectedItems.some(item => item.id === id);
      if (!already) {
        const match = this.polygonsList.find(item => item.id === id);
        if (match) {
          this.selectedItems.push(match);
        }
      }
    });
  }

  onSelectedItems(selectedItems: Array<ItemBasic>){
    if(this.mapRef){
      this.mapRef.selectFeaturesFromIds(
        selectedItems.map(item => item.id),
        false,
        true
      );
    }
  }

  onEyeClicked(item: ItemBasic){
    if(this.mapRef){
      this.mapRef.focusPolygonInMapById(item.id);
    }
    
  }

  get mapRef() {
    return this.$refs.simpleMapRef as SimpleMap
  }

  clickSaveItems(){
    if(!this.areSelectedItems){
      EventBus.$emit(TypeEventBus.SHOW_MESSAGE, 'Debe marcar un polígono en el Listado de Items', 'error');
      return
    }
    let selectedPolys = this.mapRef.selectedRanchs as Array<google.maps.Data.Feature>;
    let selectedIds = selectedPolys.map(poly => poly.getProperty('id'));
   
    let filteredFeatures = filterFeaturesById(this.yearMultiPolygon, selectedIds, 'id');
    this.changePolygonInMap(filteredFeatures, this.overwriteGeneralMap);
    this.closeModal();
    
  }



  @Emit()
  closeModal() {}

  @Emit()
  changePolygonInMap(geojson, overwrite: boolean = false) { return }

 
}

